/** @import { FC } from 'react' */
import React, { useMemo } from 'react';
import { Dropdown, Image } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import iconNew from './new.svg';
import iconWiki from './wiki.svg';
import iconMediamanager from './medienmanager.svg';
import iconNeuigkeiten from './neuigkeiten.svg';
import iconMenuMobile from './menue_mobile.svg';
import iconUpload from './upload.svg';

const AddButtonTrigger = (
  <div className="add-button-trigger">
    <Image src={iconNew} alt="Icon: Neu" />
    <span>Neu</span>
  </div>
);

/** @type {FC<{ pathname: string }>} */
const AddButton = ({ pathname }) => {
  //noinspection JSUnresolvedVariable
  const portal_type = useSelector((state) =>
    state.content.data ? state.content.data['@type'] : undefined,
  );
  const currentPath = useMemo(
    () => pathname.replace(/\/(?:contents)?$/, ''),
    [pathname],
  );

  const documentPath = useMemo(
    () => (portal_type === 'Document' ? currentPath : ''),
    [portal_type, currentPath],
  );

  const types = [
    {
      title: 'Wiki',
      type: 'Wiki',
      path: '/wiki',
      icon: iconWiki,
      visible: true,
    },
    {
      title: 'Bild',
      type: 'Image',
      path: '/medien',
      icon: iconMediamanager,
      visible: true,
    },
    {
      title: 'Datei',
      type: 'File',
      path: '/medien',
      icon: iconMediamanager,
      visible: true,
    },
    {
      title: 'Neuigkeit',
      type: 'News+Item',
      path: '/neuigkeiten',
      icon: iconNeuigkeiten,
      visible: true, // ToDo: only Editors and Admins should see this.
    },
    {
      title: 'Seite',
      type: 'Document',
      icon: iconMenuMobile,
      path: documentPath,
      visible: true, // ToDo: only Editors and Admins should see this.
    },
    {
      title: 'Massenupload',
      path: '/medien/contents',
      icon: iconUpload,
      visible: true,
    },
  ];

  return (
    <Dropdown trigger={AddButtonTrigger} button icon={false} direction="left">
      <Dropdown.Menu>
        <Dropdown.Header content="Hinzufügen" />
        {types.map((item) => (
          <Dropdown.Item
            as={Link}
            key={item.title}
            text={item.title}
            image={{ src: item.icon }}
            to={item.type ? `${item.path}/add?type=${item.type}` : item.path}
          />
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default AddButton;
